var $html = $('HTML');

$html.removeClass('no-js');

// Detecting touch
if ('ontouchstart' in window) {
	$html.addClass('touch');
} else {
	$html.addClass('no-touch');
}


// WEBPACK FOOTER //
// ./scripts/util/htmlclass/_htmlclass.js